module.exports = __webpack_public_path__ + "static/media/Endosee-Advance-HCP-Brochure-125x155@2x.c4fb7c13.jpg";